import { Component, Input } from '@angular/core';
import { MenuEntryModel } from './menu-entry.model';

@Component({
    selector: 'pace-core-menu-entry',
    templateUrl: './menu-entry.component.html',
    styleUrls: ['./menu-entry.component.scss'],
})
export class MenuEntryComponent {
    @Input()
    public model: MenuEntryModel;
}
